import api from 'shared/api'

const loadArticles = async ({ username, page }) => {
  const {
    data: list,
    headers: { 'x-total-results': total },
  } = await api.get(
    `/public/profile/${username}/articles?page=${page}&limit=20`
  )

  return { list, total }
}

const loadFollowing = async ({ username, page }) => {
  const {
    data: list,
    headers: { 'x-total-results': total },
  } = await api.get(`/public/profile/${username}/following`, {
    params: {
      page,
      limit: 20,
    },
  })

  return { list, total }
}

const loadFollowers = async ({ username, page }) => {
  const {
    data: list,
    headers: { 'x-total-results': total },
  } = await api.get(`/public/profile/${username}/followers`, {
    params: {
      page,
      limit: 20,
    },
  })

  return { list, total }
}

const loadQuestions = async ({ username, page, accessToken }) => {
  const {
    data: list,
    headers: { 'x-total-results': total },
  } = await api.get(
    `/public/profile/${username}/questions?page=${page}&limit=20`,
    {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    }
  )

  return { list, total }
}

const loadPosts = async ({ username, page, accessToken }) => {
  const {
    data: list,
    headers: { 'x-total-results': total },
  } = await api.get(`/public/profile/${username}/posts?page=${page}&limit=20`, {
    headers: {
      Authorization: `Bearer ${accessToken}`,
    },
  })

  return { list, total }
}

export const doLoadFeed = async ({ type, page, username, accessToken }) => {
  if (type === 'posts') {
    return await loadPosts({ username, page, accessToken })
  }
  if (type === 'published') {
    return await loadArticles({ username, page })
  }
  if (type === 'following') {
    return await loadFollowing({ username, page })
  }
  if (type === 'followers') {
    return await loadFollowers({ username, page })
  }
  if (type === 'questions') {
    return await loadQuestions({ username, page, accessToken })
  }
  return { list: [], total: 0 }
}
